import script from "./GoBackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoBackButton.vue?vue&type=script&setup=true&lang=js"

import "./GoBackButton.vue?vue&type=style&index=0&id=752e41b9&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-752e41b9"]])

export default __exports__